export default "/images/arrow_right.svg?e1cf9b6ebcadd026a88eb51333fe4180";